import FilterForm from 'components/forms/FilterForm';
import {
  CreateButton,
  DeleteButton,
  EditButton,
  ShowButton,
  TextField,
  useTable
} from '@refinedev/antd';
import { Form, Input, Space, Table } from 'antd';
import { HttpError } from '@refinedev/core';
import { IRole } from 'interfaces/roles';
import { ListLayout } from 'components/layout/layout/ListLayout';

export const RoleList = () => {
  const { tableProps, searchFormProps } = useTable<
    IRole,
    HttpError,
    { byName: string }
  >({
    pagination: {
      mode: 'server'
    },
    onSearch: ({ byName }) => [
      {
        field: 'filter[by_name]',
        operator: 'eq',
        value: byName
      }
    ]
  });

  return (
    <ListLayout
      title="Perfis e regras de acesso"
      headerActions={<CreateButton> Novo Perfil</CreateButton>}
    >
      <FilterForm searchFormProps={searchFormProps}>
        <Form.Item name="byName">
          <Input placeholder="Nome do perfil" className="lg:min-w-[300px]" />
        </Form.Item>
      </FilterForm>

      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="name"
          key="name"
          title="Perfil"
          width="100%"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="agents_count"
          key="agents_count"
          title="Usuários"
          align="right"
          width={120}
        />
        <Table.Column<IRole>
          title="Ações"
          dataIndex="actions"
          align="center"
          width={120}
          render={(_, record) => {
            return (
              <Space>
                <ShowButton hideText size="small" recordItemId={record.id} />
                <EditButton hideText size="small" recordItemId={record.id} />
                <DeleteButton hideText size="small" recordItemId={record.id} />
              </Space>
            );
          }}
        />
      </Table>
    </ListLayout>
  );
};
